import axios from 'axios';
import API_CONFIG from '../config/api';

// Token validation helper
const isTokenExpired = (token) => {
  if (!token) return true;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const now = Math.floor(Date.now() / 1000);
    return payload.exp < now;
  } catch (error) {
    return true;
  }
};

// Get dynamic baseURL
const getBaseURL = () => {
  return (window.ENV && window.ENV.REACT_APP_API_URL) || process.env.REACT_APP_API_URL || 'http://localhost:5000';
};

// CSRF temporarily disabled

// Create axios instance with configuration
const axiosInstance = axios.create({
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor
axiosInstance.interceptors.request.use(
  async (config) => {
    // Set baseURL dynamically on each request
    config.baseURL = getBaseURL();
    
    // If sending FormData, remove Content-Type so browser sets it with boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    
    const token = localStorage.getItem('token');
    if (token) {
      // Check if token is expired
      if (isTokenExpired(token)) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        // Don't redirect here, let the response interceptor handle it
        return Promise.reject(new Error('Token expired'));
      }
      
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 403 Forbidden errors
    if (error.response?.status === 403) {
      // Check if it's an admin-only endpoint or RBAC endpoint
      if (error.config?.url?.includes('/database/') || error.config?.url?.includes('/rbac/')) {
        // Don't auto-logout for privilege issues
      }
    }
    
    // Only logout on 401 for auth-related endpoints, not all 401s
    // But NOT for login attempts - let the login form handle its own errors
    if (error.response?.status === 401 && 
        !error.config?.url?.includes('/auth/login') &&
        (error.config?.url?.includes('/auth/') || error.config?.url?.includes('/user/permissions'))) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/';
    }
    
    return Promise.reject(error);
  }
);



// Simple API methods
export const apiCall = {
  get: (url, config) => axiosInstance.get(url, config),
  post: (url, data, config) => axiosInstance.post(url, data, config),
  put: (url, data, config) => axiosInstance.put(url, data, config),
  delete: (url, config) => axiosInstance.delete(url, config)
};

export default axiosInstance;